import permissionService from './permissionService';

export default {
    install(app) {
        // Directive pour gérer l'affichage basé sur les permissions
        app.directive('permission', {
            mounted(el, binding) {
                checkPermission(el, binding.value);

                // Réagir aux changements globaux de permissions
                window.addEventListener('permissions-updated', () => {
                    checkPermission(el, binding.value);
                });
            },
            updated(el, binding) {
                checkPermission(el, binding.value);
            }
        });

        // Directive pour désactiver les éléments sans permission
        app.directive('permission-disable', {
            mounted(el, binding) {
                checkDisable(el, binding.value);

                // Réagir aux changements globaux de permissions
                window.addEventListener('permissions-updated', () => {
                    checkDisable(el, binding.value);
                });
            },
            updated(el, binding) {
                checkDisable(el, binding.value);
            }
        });
    }
};



// Fonction pour appliquer l'affichage selon la permission
function checkPermission(el, value) {

    if (!value) {
        el.style.display = 'none';
        return;
    }

    let hasAccess = false;

    if (Array.isArray(value)) {
        hasAccess = permissionService.hasAnyPermission(value);
    } else if (typeof value === 'object') {
        if (value.any) {
            hasAccess = permissionService.hasAnyPermission(value.any);
        } else if (value.all) {
            hasAccess = permissionService.hasAllPermissions(value.all);
        } else {
            hasAccess = permissionService.hasPermission(value);
        }
    } else {
        hasAccess = permissionService.hasPermission(value);
    }

    //console.log('✅ Accès autorisé ?', hasAccess);
    el.style.display = hasAccess ? '' : 'none';
}

// Fonction pour désactiver l'élément selon la permission
function checkDisable(el, value) {
    if (!value) {
        el.disabled = true;
        return;
    }

    const hasAccess = typeof value === 'object' && value.any
        ? permissionService.hasAnyPermission(value.any)
        : typeof value === 'object' && value.all
            ? permissionService.hasAllPermissions(value.all)
            : permissionService.hasPermission(value);

    if (!hasAccess) {
        el.disabled = true;
        el.title = 'Action non autorisée';
        el.classList.add('opacity-50', 'cursor-not-allowed');
    } else {
        el.disabled = false;
        el.title = '';
        el.classList.remove('opacity-50', 'cursor-not-allowed');
    }
}
